const CONTRACT_ADDRESS = {
    'conflux': {
        'digiMart' : '0xE67aA746469116c7B44e5B8f1a980874dEb9014F',
        'marketPlace' : '0xDEd9AF35eC7e313a766DC0Fce4819F520F9a47e4',
    },
    'tron': {
        'marketPlace' : 'TBGbEGnwbhaEt9CrtcFQdyCPSLFN4HnLAx',
    }
}


export default CONTRACT_ADDRESS;
